import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges, OnChanges, OnDestroy } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { singleCustomer, DeliveryAddress } from '../../shared-html-components/customer-search/customer-search.component';
import { findPhoneNumbersInText, parsePhoneNumberFromString } from 'libphonenumber-js';
import { SharedDataService } from '../../shared/services/shared-data.service';
import * as api from '../../shared/api/apihandler';
import { SubscriptionObject } from 'app/shared/models/standard.models';
import { DAWA } from 'app/shared/utilities/dawa';

@Component({
  selector: 'app-customer-address-control',
  templateUrl: './customer-address-control.component.html',
  styleUrls: ['./customer-address-control.component.css']
})
export class CustomerAddressControlComponent implements OnInit, OnChanges, OnDestroy {
  @Input('customerId') customerId: string;
  @Input('deliveryId') deliveryId: string;
  @Input('caseId') caseId: string;
  @Input('options') options: CustomerAddressOptions = new CustomerAddressOptions();
  @Input('viewMode') viewMode: 'compact' | 'standard' | 'large' = 'standard';
  @Input() show: string;
  @Output('update') update = new EventEmitter();

  c = new CustomerController()
  valid = {
    cvr: null,
    v: new ValidAddressData(),
    i: new ValidAddressData(),
    d: new ValidAddressData()
  }

  activeView = 'v';
  addresses = [];
  roadSize = 10;

  import = new CustomerCtrlImporters();
  companyInfo;

  allowEdit = true;
  allDeliveryAddresses = [];
  copyDrag;
  subs: SubscriptionObject = {}

  constructor(private httpClient: HttpClient, private sharedData: SharedDataService) { }

  ngOnInit() {
    this.sharedData.companyInformation().subscribe((data: any) => { this.companyInfo = data; /*console.log(this.companyInfo);*/ })
  }

  ngOnChanges(change: SimpleChanges) {
    // If a new customer is input into or removed from the component, the component should update accordingly.
    // If customer Id is changes then get singleCustomer from customer-search, when customer-search is returned, deliveryId is used as ngModel of the selector.
    // If customer has an external Id, it should block the editing possibilities.
  }

  ngOnDestroy(): void {
    for(let key of Object.keys(this.subs)) this.subs[key].unsubscribe();
  }

  addCustomer() {
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') as string });
    this.httpClient.post(api.jubloApi + 'api/Website/Customer/AddCustomer', {}, { headers }).subscribe(
      (data) => { },
      (response) => { console.log('Error!', response) },
      () => { }
    )
  }

  async changeCustomer(customer: singleCustomer) {
    // if customerId is null, then just let c be a new convertedCustomerController from singleCustomer.
    // if customerId is not null, then keep the deliveryAddress and ask if it should be saved on the other customer, unless the deliveryId exists on the other customer.
    let useDeliveryAddress = await this.cloneDeliveryAddress();
    if (!!customer && customer.customerId != this.customerId) {
      this.c = await this.import.singleCustomerToCustomerController(customer, this.deliveryId, useDeliveryAddress);
      this.customerId = this.c.customerId;
      this.c.deliveryId = this.c.d.deliveryId;
      await this.getImportedCustomerCountryCodes();
      if (this.caseId != null) {
        const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') as string });
        this.httpClient.patch(api.jubloApi + 'api/Website/Case/ChangeCustomer/' + this.customerId + '/' + this.caseId, {}, { headers }).subscribe(
          (data) => { },
          (response) => { console.log('Error', response) },
          () => { },
        )
      }
    }
    else {
      this.c = await this.import.singleCustomerToCustomerController(customer, this.deliveryId, null);
      this.c.deliveryId = this.c.d.deliveryId;
      await this.getImportedCustomerCountryCodes();
      this.validate();
    }
  }

  async cloneDeliveryAddress() {
    let out = new DeliveryAddressData();
    for (let attribute in this.c.d) {
      out[attribute] = this.c.d[attribute]
    }
    out.deliveryId = null;
    return out
  }

  newCustomer() {
    let tempDelivery: DeliveryAddressData = this.c.d;
    tempDelivery.deliveryId = null;
    this.c = new CustomerController();
    this.c.d = tempDelivery;
    this.customerId = null;
    this.deliveryId = null;
  }

  newDelivery() {
    this.c.d = new DeliveryAddressData();
    this.c.deliveryId = null;
    this.valid.d = new ValidAddressData();
  }

  async updateCustomer() {
    await this.validate();
    let val = this.valid.v;
    if (!this.options.noAutoSave) {
      if (!!val.name && !!val.street && !!val.city && !!val.zipCode && !!val.phone && !!val.email) {
        let i = this.c.i;
        let d = this.c.d;
        if (i.name == '' && i.street == '' && i.zipCode == '' && i.city == '' && i.phone == '' && i.email == '') {
          this.c.i = this.c.v;
        }
        if (d.name == '' && d.street == '' && d.zipCode == '' && d.city == '' && d.phone == '' && d.email == '') {
          for (let x of Object.keys(this.c.v)) {
            this.c.d[x] = this.c.v[x];
          }
        }
      }
      if (this.c.customerId != null) {
        let phone = parsePhoneNumberFromString(this.c.v.phone, this.companyInfo.companyLanguage.slice(3));
        const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
        this.httpClient.put(api.jubloApi + 'api/Website/Customer/EditCustomer/' + this.c.customerId, {
          "name": this.c.v.name,
          "phone": phone.number,
          "address": this.c.v.street,
          "city": this.c.v.city,
          "zipCode": this.c.v.zipCode,
          "email": this.c.v.email,
          "invoiceName": this.c.i.name,
          "invoicePhone": this.c.i.phone,
          "invoiceAddress": this.c.i.street,
          "invoiceCity": this.c.i.city,
          "invoiceZipCode": this.c.i.zipCode,
          "invoiceEmail": this.c.i.email,
          att: this.c.att,
          cvr: this.c.cvr
        }, { headers }).subscribe(
          val => { },
          response => { console.log('response', response); },
          () => { });
      }
      else if (this.c.customerId == null && !!val.name && !!val.street && !!val.city && !!val.zipCode && !!val.phone && !!val.email) {

        const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
        this.httpClient.post(api.jubloApi + 'api/Website/Customer/AddCustomer', {
          companyId: this.companyInfo.id,
          customerName: this.c.v.name,
          customerAttention: '',
          customerAddress: this.c.v.street,
          customerZipCode: this.c.v.zipCode,
          customerCity: this.c.v.city,
          customerTelephone: this.c.v.phone,
          customerFax: '',
          customerEmail: this.c.v.email,
          customerMobile: this.c.v.phone,
          invoiceName: this.c.i.name,
          invoiceAddress: this.c.i.street,
          invoiceZipCode: this.c.i.zipCode,
          invoiceCity: this.c.i.city,
          invoiceTelephone: this.c.i.phone,
          invoiceFax: '',
          invoiceEmail: this.c.i.email,
          invoiceMobile: this.c.v.phone,
          customerGroupExternalId: '',
          cvr: this.c.cvr,
          att: this.c.att,
          ean: '',
          customerRemarks: '',
          externalId: null
        }, { headers }).subscribe(
          (data: string) => {
            this.c.customerId = data;
            this.customerId = data;
          },
          (response) => { console.log('Error!!', response) },
          () => { }
        )
      }
    }
  }

  async updateDelivery() {
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    await this.validate();
    let phone = this.c.d.phone != null && this.c.d.phone != '' ? parsePhoneNumberFromString(this.c.d.phone, this.companyInfo.companyLanguage.slice(3)).number : '';
    if (!this.options.noAutoSave) {
      if (this.c.deliveryId != null) {
        this.httpClient.put(api.jubloApi + 'api/Website/Customer/EditDelivery/' + this.c.deliveryId, {
          "name": this.c.d.name,
          "address": this.c.d.street,
          "city": this.c.d.city,
          "zipCode": this.c.d.zipCode,
          "mobile": phone,
          "phone": phone,
          "email": this.c.d.email
        }, { headers }).subscribe(
          val => { /*console.log('val', val);*/ },
          response => { console.log('response', response); },
          () => { }
        );
      }
      else {
        let v = this.valid.d;
        let d = this.c.d;
        if (!!v.name && !!v.street && !!v.zipCode && !!v.city && !!v.phone && !!v.email && this.customerId != null) {
          this.httpClient.post(api.jubloApi + 'api/Website/Customer/AddDeliveryAddress', {
            customerId: this.customerId,
            name: d.name,
            address: d.street,
            zipCode: d.zipCode,
            city: d.city,
            telephone: phone,
            mobile: phone,
            email: d.email,
            ean: '',
            att: ''
          }, { headers }).subscribe(
            (data: string) => { this.deliveryId = data; this.c.deliveryId = data; this.c.d.deliveryId = data; this.chooseDeliveryAddress(this.c.d) },
            (response) => { console.log('Error', response) },
            () => { }
          )
        }
      }
    }
  }

  allAreTheSame() {
    let a: any = this.c.v;
    this.c.i = a;
    this.c.d = a;
    this.validate()
  }

  chooseDeliveryAddress(d) {
    this.c.d = d
    this.deliveryId = d.deliveryId;
    this.validate();
    if (this.caseId != null && !this.options.noAutoSave) {
      const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
      this.httpClient.patch(api.jubloApi + 'api/Website/Case/ChangeDelivery/' + this.deliveryId + '/' + this.caseId, {}, { headers }).subscribe(
        (data) => { },
        (response) => { console.log('Error', response) },
        () => { }
      )
    }
  }

  getImportedCustomerCountryCodes() {
    const v = parsePhoneNumberFromString(!!this.c.v.phone ? this.c.v.phone.toString() : '', this.companyInfo.companyLanguage.slice(3));
    const i = parsePhoneNumberFromString(!!this.c.i.phone ? this.c.i.phone.toString() : '', this.companyInfo.companyLanguage.slice(3));
    const d = parsePhoneNumberFromString(!!this.c.d.phone ? this.c.d.phone.toString() : '', this.companyInfo.companyLanguage.slice(3));

    if (!!v && v.isValid()) {
      this.c.v.countryCode = v.countryCallingCode.toString();
      this.c.v.phone = v.nationalNumber.toString();
      this.valid.v.phone = true;
    }
    else { this.valid.v.phone = false; }

    if (!!i && i.isValid()) {
      this.c.i.countryCode = i.countryCallingCode.toString();
      this.c.i.phone = i.nationalNumber.toString();
      this.valid.i.phone = true;
    }
    else { this.valid.i.phone = false; }

    if (!!d && d.isValid()) {
      this.c.d.countryCode = d.countryCallingCode.toString();
      this.c.d.phone = d.nationalNumber.toString();
      this.valid.d.phone = true;
    }
    else { this.valid.d.phone = false; }
  }

  switchFocus(event) {
    if (event.srcElement.className.match('prepend')) {
      let a = event.target.parentElement.nextElementSibling;
      a.focus();
      a.select();
    }
    else if (event.target.className.match('append')) {
      let a = event.srcElement.previousElementSibling;
      a.focus();
      a.select();
    }
  }

  addressLookup(type) {
    let post = '';
    let zip = this.c[type].zipCode;
    let address = this.c[type].street;
    if (!!zip) { post = '&postnr=' + zip; }
    this.httpClient.get('https://dawa.aws.dk/adresser/autocomplete?q=' + address + post).subscribe((data: Array<DAWA>) => {
      let road = new Set();
      let roadNumber = [];
      for (var i in data) {
        road.add(data[i].adresse.vejnavn);
        let vej = data[i].adresse.vejnavn;
        if (data[i].adresse.husnr) { vej = vej + ' ' + data[i].adresse.husnr; }
        if (data[i].adresse.etage) { vej = vej + ', ' + data[i].adresse.etage + '.'; }
        if (data[i].adresse.dør) { vej = vej + ' ' + data[i].adresse.dør + '.'; }
        roadNumber.push(vej);
      }
      if (road.size > 1) { this.addresses = Array.from(road); this.roadSize = road.size }
      if (road.size == 1 && roadNumber.length > 2) { this.addresses = roadNumber; this.roadSize = 1 }
    })
  }

  cityLookup(type) {
    let zip = this.c[type].zipCode;
    zip = zip.toString();
    if (!!zip && zip.length == 4) {
      this.httpClient.get('https://dawa.aws.dk/postnumre/?nr=' + zip).subscribe((data: any) => {
        this.c[type].city = data[0].navn;
        this.validate();
      });
    } else {
      this.c[type].city = '';
    }
  }

  async validate() {
    this.validateCVR()
    for (let type of ['v', 'i', 'd']) {
      this.validateNameAddressCity(this.c[type], this.valid[type]);
      this.validateEmail(this.c[type].email, this.valid[type]);
      this.validateZip(this.c[type].zipCode, this.valid[type]);
      this.validatePhone(this.c[type], this.valid[type]);
    }
    this.update.emit(
      { 'addresses': this.c, 'validation': this.valid }
    )
  }

  validateNameAddressCity(type, validator) {
    validator['name'] = type.name != null && type.name != '' ? true : null;
    validator['street'] = type.street != null && type.street != '' ? true : null;
    validator['city'] = type.city != null && type.city != '' ? true : null;
  }

  validateEmail(mail, validator) {
    validator['email'] = mail && mail.includes('@') && mail.includes('.') ? true : mail == '' ? null : false;
    //validator['email'] = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail) ? true : false;
  }

  validateZip(z, validator) {
    validator['zipCode'] = z != null && z.toString().length > 3 ? true : z == null || z == '' ? null : false;
  }

  validatePhone(t: AddressData, valid) {
    let c = this.companyInfo.companyLanguage.slice(3)
    let tel = t.countryCode != '' ? '+' + t.countryCode + t.phone.toString() : t.phone != null && t.phone != '' ? t.phone.toString() : '';
    let phone = parsePhoneNumberFromString(tel, c);
    valid.phone = phone != null && phone.isValid() ? true : t.phone == '' ? null : false;
  }

  validateCVR() {
    if (this.c.cvr != null && this.c.cvr != '') {
      let newCVR = this.c.cvr.replace(/\D/g, '');
      this.valid.cvr = newCVR.length == 10 ? true : false;
    }
  }

  async copyMove(event) {
    if (this.copyDrag != null) {
      this.c[event] = await this.c[this.copyDrag];
      this.updateCustomer();
      this.validate();
    }
  }

  dragStart(event) {
    this.copyDrag = event;
  }

  cvrSearch(event) {

  }
}


export class CustomerController {
  customerId: string;
  deliveryId: string;
  number: string;
  att: string;
  cvr: string;
  v: AddressData = new AddressData();
  i: AddressData = new AddressData();
  d: DeliveryAddressData = new DeliveryAddressData();
  a: Array<DeliveryAddressData> = [];
}

export class AddressData {
  name: string = '';
  street: string = '';
  zipCode: string = '';
  city: string = '';
  countryCode: string = '';
  phone: string = '';
  email: string = '';
  //valid: ValidAddressData = new ValidAddressData();
}

export class ValidAddressData {
  name: boolean;
  street: boolean;
  zipCode: boolean;
  city: boolean;
  countryCode: boolean;
  phone: boolean;
  email: boolean;
  async allValid() {
    if (!!this.name && !!this.street && !!this.zipCode && !!this.city && !!this.phone && !!this.email) { return true }
    return false
  }
}

export class DeliveryAddressData extends AddressData {
  deliveryId: string;
}

export class CustomerCtrlImporters {
  singleCustomerToCustomerController(c: singleCustomer, deliveryId: string, keepDelivery): CustomerController {
    let out = new CustomerController();
    let address = c.addresses.find(x => x.deliveryId == deliveryId);
    out.deliveryId = deliveryId;
    out.customerId = c.customerId;
    out.number = c.customerNumber;
    out.att = c.att;
    out.cvr = c.cvr;
    for (let x of c.addresses) {
      out.a.push(this._deliveryToControllerAddress(x))
    }
    out.v = {
      name: c.customerName,
      street: c.customerAddress,
      zipCode: c.customerZipCode,
      city: c.customerCity,
      countryCode: '',
      phone: c.customerPhone,
      email: c.customerMail == null || c.customerMail.match('os_no_') ? '' : c.customerMail
    }
    out.i = {
      name: c.invoiceName,
      street: c.invoiceAddress,
      zipCode: c.invoiceZipCode,
      city: c.invoiceCity,
      countryCode: '',
      phone: c.invoicePhone,
      email: c.invoiceEmail == null || c.invoiceEmail.match('os_no_') ? '' : c.invoiceEmail
    }
    out.d = !!address ? this._deliveryToControllerAddress(address) : keepDelivery != null ? keepDelivery : new DeliveryAddressData();
    return out
  }

  _deliveryToControllerAddress(a: DeliveryAddress): DeliveryAddressData {
    return {
      name: a.customerName,
      street: a.customerAddress,
      zipCode: a.customerZipCode,
      city: a.customerCity,
      countryCode: '',
      phone: a.customerPhone,
      email: a.customerMail == null || a.customerMail.match('os_no_') ? '' : a.customerMail,
      deliveryId: a.deliveryId
    }
  }
}

export class DeliveryAddressSearchSelector {
  addresses: Array<DeliveryAddress>;

}

export class CustomerAddressOptions {
  hideNewCustomer?: boolean = false;
  noAutoSave?: boolean = false;
  onlyDelivery?: boolean = false;
  lockDeliveryToId?: boolean = false;
  newCustomer?: boolean = false;
  sameDelivery?: boolean = false;
  sameInvoice?: boolean = false;
}

export class AddCustomerObject {
  companyId: string = null;
  customerName: string = '';
  customerAttention: string = '';
  customerAddress: string = '';
  customerZipCode: string = '';
  customerCity: string = '';
  customerTelephone: string = '';
  customerFax: string = '';
  customerEmail: string = '';
  customerMobile: string = '';
  invoiceName: string = '';
  invoiceAddress: string = '';
  invoiceZipCode: string = '';
  invoiceCity: string = '';
  invoiceTelephone: string = '';
  invoiceFax: string = '';
  invoiceEmail: string = '';
  invoiceMobile: string = '';
  customerGroupExternalId: string = null;
  cvr: string = '';
  ean: string = '';
  customerRemarks: string = '';
  externalId: string = null;
}

export class ExportCustomerInfoObject {
  addresses: CustomerController;
  valid: CustomerAddressValidation
}

export class CustomerAddressValidation {
  v: ValidAddressData;
  i: ValidAddressData;
  d: ValidAddressData;
}
